exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/internals/object-get-own-property-symbols.js
// module id = KSd4
// module chunks = 04af